import { getCreateValue } from "./getCreateValue";

export default getCreateValue;
